// import {testURL} from '../url/index'
import request from '@/util/request'

export function textSave (text) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/text/save',
    method: 'post',
    data: text
  })
}

export function textGet () {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/text/get',
    method: 'get'
  })
}

export function textClean () {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/text/clean',
    method: 'get'
  })
}

export function fileGet (fileName) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/file/get?fileName=' + fileName,
    method: 'get'
  })
}

export function fileList () {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/file/list',
    method: 'get'
  })
}

export function fileClean () {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/file/clean',
    method: 'get'
  })
}

export function fileRemove (fileName) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/temp/file/remove?fileName=' + fileName,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/temp.js